import moment from 'moment';
import { useEffect, useState } from 'react';

export function useUnstakeAvailable(duration: number, applicableAt: number) {
  const [isAvailable, setIsAvailable] = useState(false);
  const [timeUntil, setTimeUntil] = useState('');

  useEffect(() => {
    const startStakeTime = moment.unix(applicableAt);
    const endStakeTime = startStakeTime.add(duration, 'ms');
    const now = moment();
    const timeUntil = now.diff(endStakeTime);

    if (now.isAfter(endStakeTime)) {
      setIsAvailable(true);
    } else {
      setIsAvailable(false);
      setTimeUntil(moment.duration(timeUntil).humanize());
    }
  }, [timeUntil, applicableAt]);

  return { timeUntil, isAvailable };
}
